import './App.css';
import { Switch } from './components/Switch';

function App() {
  return (
    <div className="App">
      <Switch />
    </div>
  );
}

export default App;
